import styled, { css } from 'styled-components'

export const SC_Logo = styled.div.attrs(props => ({
  
}))`
	display: flex;
    align-items: center;
	justify-content: center;
	
	position: relative;

	.icon-ratio {
		margin-top: ${props => props.margin ? (props.theme[props.margin[0]] ? props.theme[props.margin[0]] : props.margin[0]) : 0};
		margin-bottom: ${props => props.margin ? (props.theme[props.margin[1]] ? props.theme[props.margin[1]] : props.margin[1]) : 0};
	}

	canvas {
		height: ${props => props.height ? props.height : '20px'};
		max-width: 100%;
	}
    
	svg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		// height: ${props => props.height ? props.height : '20px'};
		// width: ${props => props.height ? props.height : '20px'};
		// max-width: 100%;
		// margin-top: ${props => props.margin ? (props.theme[props.margin[0]] ? props.theme[props.margin[0]] : props.margin[0]) : 0};
		// margin-bottom: ${props => props.margin ? (props.theme[props.margin[1]] ? props.theme[props.margin[1]] : props.margin[1]) : 0};

		path, polygon, g[fill] {
			fill: ${props => props.fill ? (props.theme[props.fill] ? props.theme[props.fill] : props.fill) : props.theme.white};
		}
	}
`

export const SC_IconRatio = styled.div.attrs(props => ({
	className: 'icon-ratio'
}))`
	display: block;
	position: relative;
`

export const SC_CanvasRatio = styled.canvas.attrs(props => ({
	
}))`
	display: block;
	visibility: hidden;
`